(function () {
  'use strict';

  angular.module('tf.retailer.Util')
      .factory('Activity', ActivityClass);

  function ActivityClass(Region) {

    var selectedRegion;
    function Activity(data) {
      if (!(this instanceof Activity)) return new Activity(data);
      this.regions = [];
      this.setData(data);
    }

    _.extend(Activity.prototype, {
      'constructor': Activity,
      setData : function (data) {
        var that = this;
        that.label = data.transaction;
        that.regions = _(_.map(data.region, function (region) {
          return Region(region);
        })).sortBy('labelDescription').value();
      },
      setSelectedRegion: function (region) {
        if(region){
          selectedRegion = _.find(this.regions, {label: region});
        }else{
          selectedRegion = this.hasMultipleRegion() ? this.regions[0] : null;
        }
      },
      getLabel: function () {
        return this.label;
      },
      getRegions: function () {
        return this.regions;
      },
      getSelectedRegion: function () {
        return selectedRegion;
      },
      hasMultipleRegion: function () {
        return this.regions && this.regions.length > 2;
      }
    });

    return Activity;
  }
  
  
})();  